import { useTexts } from 'utils/useTexts';
import { AssetLinks } from '@assets/assets';

const ChecklistStatusPage = () => {
  const { t } = useTexts();
  const checklistItems = [
    {
      title: 'Upload Additional Documents',
      subTitle: 'Provide additional documentation required by Lenders to complete your refinance here.',
      completed: false,
      disabled: false,
    },
    {
      title: 'Add References',
      subTitle: 'Provide Name, Address and Phone Number for three personal references here.',
      completed: true,
      disabled: false,
    },
    {
      title: 'Sign Documents',
      subTitle: 'Sign final documents to complete your refinance here.',
      completed: false,
      disabled: true,
    },
  ];

  return (
    <div>
      <div className="iLendingCDX-application-pending-container iLendingCDX-mb-4">
        <h1 className="iLendingCDX-application-pending iLendingCDX-mb-3">{t('checklistStatus.title1')}</h1>
        <h2 className="iLendingCDX-application-pending-subtitle">{t('checklistStatus.title2')}</h2>
      </div>
      <div className="iLendingCDX-section-divider"></div>
      <div>
        {checklistItems.map((item, index) => (
          <div key={index}>
            <div className={`iLendingCDX-checklist-item-container ${item.disabled && 'iLendingCDX-checklist-item-disabled'}`}>
              <div className="iLendingCDX-checklist-item">
                <h1 className="iLendingCDX-checklist-title">{item.title}</h1>
                <h2 className="iLendingCDX-application-pending-subtitle">{item.subTitle}</h2>
              </div>
              <div className="iLendingCDX-checklist-image-container">
                <img
                  src={item.completed ? `${AssetLinks.greenTick}` : `${AssetLinks.rightArrow}`}
                  alt={item.completed ? 'Completed' : 'Pending'}
                />
              </div>
            </div>
            <div className="iLendingCDX-section-divider"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChecklistStatusPage;
